import _ from 'lodash';
import Vue from 'vue';
/**
 * Click outside directive
 * Implementation from http://wffranco.github.io/vue-strap/
 */
const HANDLER = '_vue_scroll_handler';
const events = ['resize', 'scroll'];

function unbind(el) {
    _.forEach(events, (e) => {
        window.removeEventListener(e, el[HANDLER], false);
    });
    document.removeEventListener('load', el[HANDLER], false);
    // eslint-disable-next-line no-param-reassign
    delete el[HANDLER];
}

function bind(el, binding) {
    unbind(el);

    const callback = binding.value;
    if (!_.isFunction(callback)) {
        if (process.env.NODE_ENV !== 'production') {
            Vue.util.warn(
                `ClickOutside only work with a function value, received: v-${binding.name}="${binding.expression}"`
            );
        }
    } else {
        // eslint-disable-next-line no-param-reassign
        el[HANDLER] = function (e) {
            callback(e);
        };
        _.forEach(events, (e) => {
            window.addEventListener(e, el[HANDLER], false);
        });
        document.addEventListener('load', el[HANDLER], false);
        setTimeout(() => {
            el[HANDLER]();
        }, 0);
    }
}

export default {
    bind,
    unbind,
    update(el, binding) {
        if (binding.value !== binding.oldValue) {
            bind(el, binding);
        }
    },
};
